import { useQuery } from '@tanstack/react-query'

import { getEmployeeVcnCards } from '../../../api/vcn-management-api-client'

export const EMPLOYEE_VCN_CARDS_QUERY_KEY = 'vcn-management-employee-cards'

/**
 * All VCN cards for an employee family (both providers), for the expandable
 * "Associated VCNs" sub-table. Disabled until an employeePublicKey is known and
 * the row is expanded, so collapsed rows never fetch.
 */
export function useEmployeeVcnCards(
  employeePublicKey: string | undefined,
  enabled: boolean
) {
  return useQuery({
    queryKey: [EMPLOYEE_VCN_CARDS_QUERY_KEY, employeePublicKey],
    queryFn: () => getEmployeeVcnCards(employeePublicKey as string),
    enabled: enabled && Boolean(employeePublicKey),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  })
}
